import { useCallback } from 'react';

import { useRadarForegroundTracking as useRadarForegroundTrackingBase } from '@sg/radar-fe';

import { useFeatureFlag } from '@order/LaunchDarkly';
import { useTelemetry } from '@order/Telemetry';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Order-app wrapper for Radar foreground tracking.
 *
 * Reads the feature flag and wires telemetry, then delegates
 * to the platform hook in `@sg/radar-fe`.
 */
export function useRadarForegroundTracking() {
  const isEnabled = useFeatureFlag('CELS-4898-radar-geofence-enabled');

  const { track } = useTelemetry();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const onTrackOnce = useCallback(
    (status: string) => {
      track('radar.track_once', { status });
    },
    [track],
  );

  // ─────────────────────────────────────────────────────────────────────

  useRadarForegroundTrackingBase({ isEnabled, onTrackOnce });
}
